import { Component, OnInit, inject } from '@angular/core';
import { FormControl, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { CampaignAdminRequest, CampaignsCampaignAdminApiClient, CoinReward, ConsumptionFilterStrategy, LuckyDrawStrategy, ProductReward, RewardChance } from 'src/app/api/api-campaigns.service.generated';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { ButtonComponent } from "wecheer-common";
import { lastValueFrom } from 'rxjs';

@Component({
  selector: 'app-campaign-json-edit',
  templateUrl: './campaign-json-edit.component.html',
  styleUrls: ['./campaign-json-edit.component.scss'],
  imports: [
    ReactiveFormsModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    ButtonComponent
  ]
})
export class AdvertiserCampaignJsonEditComponent implements OnInit {
  private campaignsApi = inject(CampaignsCampaignAdminApiClient);
  private dialogRef = inject<MatDialogRef<AdvertiserCampaignJsonEditComponent, CampaignAdminRequest | undefined>>(MatDialogRef);
  editModel = inject<CampaignAdminRequest>(MAT_DIALOG_DATA);

  static config = { height: 'auto', width: 'auto' };
  form: FormGroup = new FormGroup({
    json: new FormControl('', Validators.required)
  });

  ngOnInit() {
    let model = this.editModel;

    if (!model.title)
      model = new CampaignAdminRequest({
        title: 'Title of the campaign',
        description: 'Description of the campaign',
        startDate: new Date(2020, 10, 10),
        endDate: new Date(2021, 10, 10),
        advertiserId: this.editModel.advertiserId,
        punchCardStrategy: null,
        luckyDrawStrategy: new LuckyDrawStrategy({
          chanceCount: 12,
          maxChancesPerConsumptionEvent: 1,
          consumptionFilters: [new ConsumptionFilterStrategy({ score: 8, wildCard: '*modelo*' })],
          scorePerChance: 12,
          rewardChances: [
            new RewardChance({ coinReward: new CoinReward({ coins: 100 }), chance: 0.1 }),
            new RewardChance({
              productReward: new ProductReward({
                productSlug: 'product-slug',
                rewardDescription: 'A super product used only for demo',
                rewardTitle: 'Demo product'
              }), chance: 0.9
            })
          ]
        }),
        shouldAdvertise: true,
        canJoin: true
      });

    this.form.patchValue({ json: JSON.stringify(model, null, 2) });
  }

  async onSubmit() {
    const f = this.form.value;
    const model: CampaignAdminRequest = JSON.parse(f.json);
    const o = await lastValueFrom(this.campaignsApi.createCampaign(model));
    //this.snackBar.open(`Campaign ${model.title} was saved`, null, { duration: 3000 });
    this.dialogRef.close(o);
  }

  async onClose() {
    this.dialogRef.close(undefined);
  }
}
